/**
 * @type {BenchConfig}
 */
const benchConfig = window.BENCH;

module.exports = angular.module('bench.config.global', []).constant('config', benchConfig);

// This is normally provided in main-app
// so it is needed for rind-only dev.
angular.module('bench.main-app', []).constant('MainAppConfig', {
  mock: true,
  routes: {
    'bench.dms': '/new-folders',
    'bench.clientCard': '/card',
    'bench.categorizer': '/categorizer',
    'bench.messaging': '/new-dashboard',
    'bench.account': '/accounts',
  },
});
